import Link from 'next/link';
import { RiDiscordFill, RiTwitterXFill } from 'react-icons/ri';
import { FaTelegramPlane } from 'react-icons/fa';
export default function SocialData() {
  return <>
      <div className='mt-6 social flex justify-center items-center text-genius-pink w-full ta-c self-end'>
        <div className='flex flex-col w-1/3 border-genius-blue items-center'>
          <div className='items-center h-16 flex'>
            <Link target='_blank' href='https://x.com/GeniusTerminal' aria-label='GeniusTerminal on X' data-sentry-element="Link" data-sentry-source-file="socialData.tsx">
              <RiTwitterXFill className='cursor-pointer' size={20} data-sentry-element="RiTwitterXFill" data-sentry-source-file="socialData.tsx" />
              <span className='text-genius-cream text-xs'>Twitter</span>
            </Link>
          </div>
        </div>
        <div className='flex flex-col w-1/3 border-genius-blue border-x-[1px]  items-center'>
          <div className='items-center h-16 flex'>
            <Link target='_blank' href={'https://discord.com/invite/geniusterminal'} aria-label='GeniusTerminal on Discord' data-sentry-element="Link" data-sentry-source-file="socialData.tsx">
              <RiDiscordFill className='cursor-pointer' size={20} data-sentry-element="RiDiscordFill" data-sentry-source-file="socialData.tsx" />
              <span className='text-genius-cream text-xs'>Discord</span>
            </Link>
          </div>
        </div>
        <div className='flex flex-col w-1/3 border-genius-blue  items-center'>
          <div className='items-center h-16 flex'>
            <Link target='_blank' href='https://t.me/geniusverification' aria-label='GeniusTerminal on Telegram' data-sentry-element="Link" data-sentry-source-file="socialData.tsx">
              <FaTelegramPlane className='cursor-pointer' size={20} data-sentry-element="FaTelegramPlane" data-sentry-source-file="socialData.tsx" />
              <span className='text-genius-cream text-xs'>Telegram</span>
            </Link>
          </div>
        </div>
      </div>
    </>;
}